import createApiRequest from '@/lib/axios/createApiRequest';

export default function deleteOpportunity(opportunityId: string) {
  return createApiRequest({
    method: 'delete',
    path: `opportunities/${opportunityId}`,
    throwErrors: true,
  });
}
